import { z } from 'zod';

import { idSchema, isoDateSchema, jsonMetaSchema } from './common.schema';

export const gdprRequestKindSchema = z.enum(['erasure', 'export', 'rectification', 'objection']);
export const gdprRequestStatusSchema = z.enum([
  'pending',
  'in_review',
  'approved',
  'completed',
  'rejected',
]);

export const gdprRequestSchema = z.object({
  id: idSchema,
  workspace_id: idSchema,
  contact_id: idSchema.nullable().optional(),
  kind: gdprRequestKindSchema,
  status: gdprRequestStatusSchema,
  requester_email: z.string().nullable().optional(),
  requester_phone: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  scheduled_for: isoDateSchema.nullable().optional(),
  completed_at: isoDateSchema.nullable().optional(),
  export_file_url: z.string().url().nullable().optional(),
  export_file_expires_at: isoDateSchema.nullable().optional(),
  meta: jsonMetaSchema,
  created_at: isoDateSchema,
  updated_at: isoDateSchema,
});

export const createGdprRequestSchema = z.object({
  kind: gdprRequestKindSchema,
  contact_id: idSchema.optional(),
  requester_email: z.string().email().optional(),
  requester_phone: z.string().optional(),
  description: z.string().max(5000).optional(),
});

export const decideGdprRequestSchema = z.object({
  decision: z.enum(['approve', 'reject']),
  comment: z.string().max(2000).optional(),
});
